// Converted to lazy loading
const CallCenterIndex = () => import('@/pages/callCenter/callCenter/index.vue')
const callCenterForm = () => import('@/pages/callCenter/callCenter/form.vue')
const CallCenterInvoices = () => import('@/pages/callCenter/salesApp/invoices.vue')

const callCenterShow = () => import('@/pages/callCenter/salesApp/index.vue')

const routes = [
  {
    path: 'callCenter',
    name: 'callCenter',
    component: CallCenterIndex
  },
  {
    path: 'callCenter/create',
    name: 'callCenterCreate',
    component: callCenterForm
  },

  {
    path: 'callCenter/:id/edit',
    name: 'callCenterEdit',
    component: callCenterForm
  },
  {
    path: 'callCenter/:id',
    name: 'callCenterShow',
    component: callCenterShow
  },
  {
    path: 'callCenter/:id/invoices',
    name: 'callCenterInvoices',
    component: CallCenterInvoices
  }
]

export default routes
